/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GiftingMutationMutationVariables = {|
  phoneNumber: string,
  email: string,
  name: string,
  company: string,
|};
export type GiftingMutationMutationResponse = {|
  +giftingMutation: ?{|
    +message: ?string,
    +status: ?string,
  |}
|};
export type GiftingMutationMutation = {|
  variables: GiftingMutationMutationVariables,
  response: GiftingMutationMutationResponse,
|};
*/


/*
mutation GiftingMutationMutation(
  $phoneNumber: String!
  $email: String!
  $name: String!
  $company: String!
) {
  giftingMutation(company: $company, email: $email, name: $name, phoneNumber: $phoneNumber) {
    message
    status
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "company"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "email"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "phoneNumber"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "company",
        "variableName": "company"
      },
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "phoneNumber",
        "variableName": "phoneNumber"
      }
    ],
    "concreteType": "GiftingMutation",
    "kind": "LinkedField",
    "name": "giftingMutation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GiftingMutationMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GiftingMutationMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "0dc2b69398ad5f5a93414f432a20be53",
    "id": null,
    "metadata": {},
    "name": "GiftingMutationMutation",
    "operationKind": "mutation",
    "text": "mutation GiftingMutationMutation(\n  $phoneNumber: String!\n  $email: String!\n  $name: String!\n  $company: String!\n) {\n  giftingMutation(company: $company, email: $email, name: $name, phoneNumber: $phoneNumber) {\n    message\n    status\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '95aa133257d6e7cb1077fbf81bfd8516';

module.exports = node;
